import React from 'react';
import 'trade-in-360/components/InstantEstimateWrapper/Components/VehicleTypeLabel/VehicleTypeLabel.scss';

const VehicleTypeLabel = ({ vehicleLabel, vehicleInfo, isVehicleBold = false, children }) => {
    if (!vehicleLabel || !vehicleInfo) {
        return null;
    }

    const commonClassnames = 'sr-text is-inline';
    let labelClass = `${commonClassnames} vehicle-label`;
    let vehicleClass = commonClassnames;

    if (!isVehicleBold) labelClass += ' is-bold';
    if (isVehicleBold) vehicleClass += ' is-bold';

    return (
        <div className="vehicle-type-label">
            <div className="vehicle-type-label--text">
                <span className={labelClass}>{vehicleLabel}</span>
                <span className={vehicleClass}>{vehicleInfo}</span>
            </div>
            <span className="vehicle-type-label--children">{children}</span>
        </div>
    );
};
VehicleTypeLabel.displayName = 'VehicleTypeLabel';

export default VehicleTypeLabel;
